// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const CashFlowForecastPage = lazy(() => import('./pages/CashFlowForecastPage'));
const WorkingCapitalPage = lazy(() => import('./pages/WorkingCapitalPage'));
const ProfitabilityPage = lazy(() => import('./pages/ProfitabilityPage'));
const VariancePage = lazy(() => import('./pages/VariancePage'));
const RatiosPage = lazy(() => import('./pages/RatiosPage'));
const BenchmarkingPage = lazy(() => import('./pages/BenchmarkingPage'));
const UnitEconomicsPage = lazy(() => import('./pages/UnitEconomicsPage'));

export const AnalyticsRoutes: RouteObject = {
  path: 'analytics',
  element: <ModuleGuard moduleId="finance.analytics" />,
  children: [
    { path: 'cash-flow-forecast', element: <CashFlowForecastPage />, handle: { crumb: 'Cash Flow Forecast' } },
    { path: 'working-capital', element: <WorkingCapitalPage />, handle: { crumb: 'Working Capital' } },
    { path: 'profitability', element: <ProfitabilityPage />, handle: { crumb: 'Profitability' } },
    { path: 'variance', element: <VariancePage />, handle: { crumb: 'Variance' } },
    { path: 'ratios', element: <RatiosPage />, handle: { crumb: 'Ratios' } },
    { path: 'benchmarking', element: <BenchmarkingPage />, handle: { crumb: 'Benchmarking' } },
    { path: 'unit-economics', element: <UnitEconomicsPage />, handle: { crumb: 'Unit Economics' } },
  ],
};
